import { render, staticRenderFns } from "./ReplaceItemOverlay.vue?vue&type=template&id=3e56b0c3&scoped=true"
import script from "./ReplaceItemOverlay.vue?vue&type=script&lang=js"
export * from "./ReplaceItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ReplaceItemOverlay.vue?vue&type=style&index=0&id=3e56b0c3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e56b0c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e56b0c3')) {
      api.createRecord('3e56b0c3', component.options)
    } else {
      api.reload('3e56b0c3', component.options)
    }
    module.hot.accept("./ReplaceItemOverlay.vue?vue&type=template&id=3e56b0c3&scoped=true", function () {
      api.rerender('3e56b0c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/browser/item-overlays/ReplaceItemOverlay.vue"
export default component.exports